<script>
  import { slide } from 'svelte/transition'
  import { auth } from '../../services/auth.js'
  import Alert from '../../components/Alert.svelte'

  var email = ''
  var submitting = false
  var codeSent = false
  var passUpdated = false
  var errorMsg = null
  var successMsg = null

  // Step 1: Sending Code
  function validEmail() {
    var elem = document.getElementById('email')
    email = elem.value
    return elem.checkValidity()
  }

  function sendCode() {
    if (validEmail()) {
      submitting = true
      auth.sendResetCode(setCodeSent)
    } else {
      errorMsg = 'Invalid email format!'
    }
  }

  function setCodeSent(result, msg) {
    submitting = false
    codeSent = result
    successMsg = result ? 'Code Sent!' : null
    errorMsg = result ? null : msg
  }

  // Step 2: Updating Password
  function validReset() {
    var code = document.getElementById('code')
    var pass = document.getElementById('newPassword')

    if (!code.checkValidity()) {
      errorMsg = "You've entered an invalid code!"
      return false
    }

    if (!pass.checkValidity()) {
      errorMsg = 'Your password does not meet the minimum requirements!'
      return false
    }

    return true
  }

  function resetPass() {
    successMsg = null
    errorMsg = null

    if (validReset()) {
      submitting = true
      auth.resetPass(email, setPassUpdated)
    }
  }

  function setPassUpdated(result) {
    submitting = false
    passUpdated = result
    successMsg = result ? 'Password Updated!' : null
    errorMsg = result ? null : 'Something went wrong! Please try again.'
  }
</script>

<style type="text/less">
  .container {
    padding: var(--spacing-sm);
  }
  @media (min-width: 800px) {
    .container {
      padding: var(--spacing);
    }
  }
</style>

<div class="container">
  <div class="user-cont" transition:slide>
    <div class="user-content">
      <h1 class="user-title">Reset Password</h1>

      <div class="user-form">

        {#if successMsg}
          <Alert type="success" icon="check" inline>{successMsg}</Alert>
        {/if}
        {#if errorMsg}
          <Alert type="danger" icon="warning">{errorMsg}</Alert>
        {/if}

        {#if !codeSent}
          <p>
            Enter the email address associated with your account to retrieve a
            one-time code that will allow you to reset your password.
          </p>
        {:else if !passUpdated}
          <p>
            If an account with the submitted email address exists, a secret
            one-time code will be sent to you. Enter that code and your new
            password in the fields below.
          </p>
        {/if}

        {#if !codeSent}
          <div class="form-field">
            <label class="form-field-label" for="email">Email Address</label>
            <input
              class="form-input"
              id="email"
              name="email"
              type="email"
              required />
          </div>
        {:else if !passUpdated}
          <div class="form-field">
            <label class="form-field-label" for="code">Verification Code</label>
            <input
              class="form-input"
              type="text"
              id="code"
              name="code"
              autocomplete="new-password"
              pattern={'[0-9]{6}'}
              required />
          </div>
          <div class="form-field">
            <label class="form-field-label" for="newPassword">
              New Password
            </label>
            <p class="form-field-message">
              Minimum 8 characters, a number, a lowercase and uppercase letter,
              and a special character.
            </p>
            <input
              class="form-input"
              type="password"
              id="newPassword"
              name="newPassword"
              autocomplete="new-password"
              pattern={'(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^$*.\\[\\]{}()?-“!@#%&/,><’:;|_~`])\\S{8,99}'}
              required />
          </div>
        {:else}
          <p class="text-right">
            <a
              href="/login?referrer={window.location.pathname}"
              class="btn btn-link">
              Sign In
              <svg class="icon">
                <use href="/icons.svg#keyboard_arrow_right" />
              </svg>
            </a>
          </p>
        {/if}

        {#if !passUpdated}
          <div class="form-field">
            <button
              class="btn btn-expanded"
              on:click|preventDefault={!codeSent ? sendCode : resetPass}>
              {#if submitting}
                <svg class="icon spin">
                  <use href="/icons.svg#circle_notch" />
                </svg>
                Submitting...
              {/if}

              {#if !submitting && !codeSent}
                Send Code
              {:else if !submitting}Reset Password{/if}
            </button>
          </div>
        {/if}
      </div>

      {#if !passUpdated}
        <p class="user-form-links">
          <a href="/login?referrer={window.location.pathname}">
            Remember Password?
          </a>
          |
          <a href="/register">Not a member? Sign Up!</a>
        </p>
      {/if}
    </div>
  </div>
</div>
